import { useAppSelector } from '../../hooks';

export const useSavedQuotesListOpened = () => {
  return useAppSelector(state => state.ui.appMenu.savedQuotesOpened);
};
